// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__PX7mc","productName":"Table_productName__YhZgL"};